/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The TravelCostErrorsInner model module.
 * @module model/TravelCostErrorsInner
 * @version 0.0.2
 */
class TravelCostErrorsInner {
    /**
     * Constructs a new <code>TravelCostErrorsInner</code>.
     * @alias module:model/TravelCostErrorsInner
     * @param errorMessage {module:model/TravelCostErrorsInner.ErrorMessageEnum} A human-readable message describing the error encountered during the cost matrix calculation.
     */
    constructor(errorMessage) { 
        
        TravelCostErrorsInner.initialize(this, errorMessage);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, errorMessage) { 
        obj['errorMessage'] = errorMessage;
    }

    /**
     * Constructs a <code>TravelCostErrorsInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TravelCostErrorsInner} obj Optional instance to populate.
     * @return {module:model/TravelCostErrorsInner} The populated <code>TravelCostErrorsInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TravelCostErrorsInner();

            if (data.hasOwnProperty('errorMessage')) {
                obj['errorMessage'] = ApiClient.convertToType(data['errorMessage'], 'String');
            }
            if (data.hasOwnProperty('errorDescription')) {
                obj['errorDescription'] = ApiClient.convertToType(data['errorDescription'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>TravelCostErrorsInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>TravelCostErrorsInner</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of TravelCostErrorsInner.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['errorMessage'] && !(typeof data['errorMessage'] === 'string' || data['errorMessage'] instanceof String)) {
            throw new Error("Expected the field `errorMessage` to be a primitive type in the JSON string but got " + data['errorMessage']);
        }
        // ensure the json data is a string
        if (data['errorDescription'] && !(typeof data['errorDescription'] === 'string' || data['errorDescription'] instanceof String)) {
            throw new Error("Expected the field `errorDescription` to be a primitive type in the JSON string but got " + data['errorDescription']);
        }

        return true;
    }


}

TravelCostErrorsInner.RequiredProperties = ["errorMessage"];

/**
 * A human-readable message describing the error encountered during the cost matrix calculation.
 * @member {module:model/TravelCostErrorsInner.ErrorMessageEnum} errorMessage
 */
TravelCostErrorsInner.prototype['errorMessage'] = undefined;

/**
 * A more detailed description of the error encountered during the cost matrix calculation.
 * @member {String} errorDescription
 */
TravelCostErrorsInner.prototype['errorDescription'] = undefined;





/**
 * Allowed values for the <code>errorMessage</code> property.
 * @enum {String}
 * @readonly
 */
TravelCostErrorsInner['ErrorMessageEnum'] = {

    /**
     * value: "Missing latitude or longitude for at least one location."
     * @const
     */
    "Missing latitude or longitude for at least one location.": "Missing latitude or longitude for at least one location.",

    /**
     * value: "Invalid vehicle type specified for at least one entry."
     * @const
     */
    "Invalid vehicle type specified for at least one entry.": "Invalid vehicle type specified for at least one entry.",

    /**
     * value: "Routing service unavailable."
     * @const
     */
    "Routing service unavailable.": "Routing service unavailable.",

    /**
     * value: "Unable to calculate travel cost between at least one pair of locations."
     * @const
     */
    "Unable to calculate travel cost between at least one pair of locations.": "Unable to calculate travel cost between at least one pair of locations.",

    /**
     * value: "Unknown error."
     * @const
     */
    "Unknown error.": "Unknown error."
};



export default TravelCostErrorsInner;

